module.exports = __webpack_public_path__ + "static/media/reinavictoria_deusto.d93fd6ec.png";